function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hotel location pin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M102,323.207v-205.1a32.037,32.037,0,0,1,32-32H104a32.037,32.037,0,0,0-32,32v205.1a32.036,32.036,0,0,0,32,32h30A32.036,32.036,0,0,1,102,323.207Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,74.111H104a44.05,44.05,0,0,0-44,44v205.1a44.049,44.049,0,0,0,44,44h97.832l22.4,57.111a5.913,5.913,0,0,0-4.979-2.062c-27.763,2.043-52.9,6.665-70.794,13.013C127.583,442.675,117,452.034,117,463.088c0,27.49,68.5,41.873,136.17,41.873,60.976,0,113.069-11.318,129.627-28.165,4.184-4.257,6.27-8.886,6.2-13.759-.032-10.884-10.482-20.124-31.06-27.466-17.739-6.329-42.655-10.937-70.16-12.974a6,6,0,1,0-.887,11.966C348.361,439.118,377,454.276,377,463.088c0,.034,0,.069,0,.1.026,1.555-.9,3.3-2.761,5.193-12,12.213-57.446,24.577-121.069,24.577-34.194,0-66.3-3.654-90.4-10.29C139.443,476.246,129,468.206,129,463.088c0-8.936,28.962-24.288,91.128-28.865a6,6,0,0,0,5.549-6.209L242.8,471.668a6.13,6.13,0,0,0,.524,1.031,11.206,11.206,0,0,0,18.908,0,5.984,5.984,0,0,0,.524-1.031l40.964-104.461H408a44.049,44.049,0,0,0,44-44v-205.1A44.05,44.05,0,0,0,408,74.111Zm32,249.1a32.036,32.036,0,0,1-32,32H299.623a6,6,0,0,0-5.586,3.81L252.773,464.242,211.509,359.017a6,6,0,0,0-5.586-3.81H104a32.036,32.036,0,0,1-32-32v-205.1a32.037,32.037,0,0,1,32-32H408a32.037,32.037,0,0,1,32,32Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,204.884a6,6,0,0,0-6,6v24.232H132V138.325a6,6,0,0,0-12,0v175.35a6,6,0,0,0,12,0V277.349H380v36.326a6,6,0,0,0,12,0V210.884A6,6,0,0,0,386,204.884ZM132,265.349V247.116H380v18.233Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.026,198.791A30.186,30.186,0,1,0,177.212,168.6,30.22,30.22,0,0,0,147.026,198.791Zm48.372,0A18.186,18.186,0,1,1,177.212,180.6,18.207,18.207,0,0,1,195.4,198.791Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.577,162.559H221.926a6,6,0,0,0-6,6v54.418a6,6,0,0,0,6,6H361a6,6,0,0,0,6-6A60.487,60.487,0,0,0,306.577,162.559Zm-78.651,54.418V174.559h78.651a48.493,48.493,0,0,1,48.049,42.418Z",
    style: {
      fill: "#2eca8b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.c5d99eb4bbe0af5895a60e79886b6acf.svg";
export { ForwardRef as ReactComponent };